import { render, staticRenderFns } from "./ProfProfileOverview.vue?vue&type=template&id=a1e393c2&"
import script from "./ProfProfileOverview.vue?vue&type=script&lang=js&"
export * from "./ProfProfileOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports